import { Injectable } from '@angular/core';
import { ICvxClaimsPrincipal } from '@cvx/cal';
import { AuthenticationResult } from '@azure/msal-common';
import { CalAngularService } from '@cvx/cal-angular';
import { Observable, BehaviorSubject, map, lastValueFrom } from 'rxjs';
import { AppConfig } from '../core/service/app-config.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CalService {
  public logout() {
    this.cal.userInitiatedSignOut();
  }

  private cal: CalAngularService;
  private userSubject: BehaviorSubject<ICvxClaimsPrincipal> =
    new BehaviorSubject({} as ICvxClaimsPrincipal);
  private isLoggedInSubject: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  constructor(authService: CalAngularService) {
    this.cal = authService;
  }

  async updateAccessToken(): Promise<string> {
    const graphScopes = AppConfig.settings.graphScopes.slice(0);
    graphScopes.unshift(`${environment.apiEndpoint}/user_impersonation`);
    const token: Promise<string> = this.getAADToken(
      graphScopes,
      false
    ) as Promise<string>;
    return token;
  }

  async getAADToken(
    oidcScopes: string[] = AppConfig.settings.oidcScopes,
    fullAuthResponse: boolean = false
  ): Promise<string | AuthenticationResult | null> {
    return lastValueFrom(this.cal.getAADToken(oidcScopes, fullAuthResponse));
  }

  isUserLoggedIn(): Observable<boolean> {
    return this.isLoggedInSubject.asObservable();
  }

  getUserInfo(): Observable<ICvxClaimsPrincipal> {
    return this.userSubject.asObservable();
  }

  public getFirstName() {
    return this.userSubject.pipe(
      map((user) => {
        if (user.name) {
          return user.name.split(',')[1].split('[')[0];
        }
        return '';
      })
    );
  }

  async signIn(): Promise<boolean> {
    // get Microsoft access token
    return lastValueFrom(this.cal.userInitiatedSignIn()).then(async (data) => {
      this.userSubject.next(data);
      this.isLoggedInSubject.next(data != null);
      // update the token to be able to reach out to the backend
      await this.updateAccessToken();
      if (!data) {
        console.error('User failed to log in.');
      }

      return data != null;
    });
  }
}
